import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useFileDownloader from '../../useFileDownloader';

const useDownloadTripLogTemplate = () => {
    const request = useFileDownloader();
    const [loading, setLoading] = useState(false);

    const onDownloadTripLogTemplateError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while downloading trip log template'
        );
    };

    const onDownloadTripLogTemplateSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success("Trip log template started downloading");
    };

    const downloadTripLogTemplate = (version: number = 1) => {
        const url: HttpConfig = {
            url: `api/v1/trip-logs/get-excel-sample?sampleVersion=${version}`,
            method: 'get',
        };

        request(url, onDownloadTripLogTemplateSuccess, setLoading, onDownloadTripLogTemplateError, 'TripLogTemplate.xlsx');
    };

    return { downloadTripLogTemplate, loading };
};

export default useDownloadTripLogTemplate;

